import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';
import { DeleteOutline, EditOutlined, SendOutlined, FlagOutlined, MoreHoriz } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import {
  BranchDetailsTabIcon,
  BranchDetailsTabIconDone,
  EmployeesTabIcon,
  EmployeesTabInprogress,
  EmployeesTabDone,
  BranchDetailsTabInprogress,
  SpecialtiesServicesTabIcon,
  SpecialtiesServicesTabInprogress,
  SpecialtiesServicesTabDone,
  BookingsTabIcon,
  BookingsTabInprogressIcon,
  BookingsTabDoneIcon,
} from '../../../utils/Icons';
import { setPageMainTitle, renderTextEllipsis } from '../../../utils/Helpers';
import { ROUTE_PATHS } from '../../../utils/RoutesPaths';
import Stepper from '../../../components/Stepper';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import Breadcrumbs from '../../../components/BreadCrumbs';
import Input from '../../../components/Input';
import messages from '../../../assets/locale/messages';
import ViewBranchDetails from './ViewBranchDetails';
import ViewServicesDetails from './ViewServicesDetails';
import ViewEmployeesDetails from './ViewEmployeesDetails';
import ViewBookingsDetails from './ViewBookingsDetails';
import {
  deleteBranchRequest,
  editBranchRequest,
  getBranchRequest,
  getRequestStatus,
} from '../../../store/Branches/actions';
import { getGoogleMapsPolygon, saveBranchData } from '../../../store/GoogleMapCoords/actions';
import ViewReviewsDetails from './ViewReviewsDetails';
import { ReviewsTab } from '../../../utils/Icons/ReviewsTab';
import { ReviewsTabInprogress } from '../../../utils/Icons/ReviewsTabInprogress';
import './ViewBranch.scss';
import { isSuperAdmin } from '../../../utils/Permissions';

const ViewBranch = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();
  const urlParams = new URLSearchParams(window.location.search);
  const currentTab = +urlParams.get('CurrentTab') || 1;
  const lang = useSelector((state) => state.locale.lang);
  const { pagesTitles, branches, shared, publishRequests } = messages[lang];
  const createdBranch = useSelector((state) => state.branches.addedBranch);
  const branchData = useSelector((state) => state.branches.branchDetails); // get by id
  const requestStatus = useSelector((state) => state.branches.requestStatus);

  const [isPublishRequest, setIsPublishRequest] = useState(false);
  // const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex, setTabIndex] = useState(currentTab-1);
  const [btnClicked, setBtnClicked] = useState(null);
  const [renderList, setRenderList] = useState(false);
  const [renderSubTitle, setRenderSubTitle] = useState(null);
  const [pageTitle, setPageTitle] = useState('');
  const [renderServiceTitle, setRenderServiceTitle] = useState(null);
  const [showDeleteBranchModal, setShowDeleteBranchModal] = useState(false);
  const [showDeleteBranchEmployeeModal, setShowDeleteBranchEmployeeModal] = useState(false);
  const [stepperItems, setStepperItems] = useState([]);
  const [showRejectRequestModal, setShowRejectRequestModal] = useState(false);
  const [showRejectionReason, setShowRejectionReason] = useState(false);

  useEffect(() => {
    setTabIndex(currentTab-1);
  }, [urlParams.get('CurrentTab')]);

  useEffect(() => {
    dispatch(saveBranchData({}))
    return () => {
      dispatch(getRequestStatus(null));
    };
  }, []);

  const { values, handleSubmit, setFieldTouched, setFieldValue, touched, errors } = useFormik({
    initialValues: { reason: '' },
    validationSchema: Yup.object({
      reason: Yup.string().required('Required'),
    }),
    onSubmit: async ({ reason }) => {
      dispatch(
        editBranchRequest({
          id,
          data: {
            rejection_reasons_attributes: [{ reason }],
            status: 'unpublished',
          },
        })
      );
      setShowRejectRequestModal(false);
    },
  });

  useEffect(() => {
    if (requestStatus) {
      if (location.pathname.includes('publish-request')) {
        history.push(ROUTE_PATHS.publishRequests);
      }
      dispatch(getBranchRequest(id));
    }
  }, [requestStatus]);

  useEffect(() => {
    if (location.pathname.includes('publish-request')) {
      setIsPublishRequest(true);
    }
    setPageMainTitle('branchesManagement');
    setPageTitle(lang === 'en' ? branchData?.name_en : branchData?.name_ar);
    dispatch(getBranchRequest(id));
    dispatch(getGoogleMapsPolygon([]));
  }, []);

  useEffect(() => {
    if (isPublishRequest) {
      setStepperItems([
        {
          label: branches.viewBranch.firstTab,
          icon: [<BranchDetailsTabIcon />, <BranchDetailsTabInprogress />, <BranchDetailsTabIconDone />],
        },
        {
          label: branches.viewBranch.secondTab,
          icon: [<SpecialtiesServicesTabIcon />, <SpecialtiesServicesTabInprogress />, <SpecialtiesServicesTabDone />],
        },
        {
          label: branches.viewBranch.thirdTab,
          icon: [<EmployeesTabIcon />, <EmployeesTabInprogress />, <EmployeesTabDone />],
        },
      ]);
    } else {
      setStepperItems([
        {
          label: branches.viewBranch.firstTab,
          icon: [<BranchDetailsTabIcon />, <BranchDetailsTabInprogress />, <BranchDetailsTabIconDone />],
        },
        {
          label: branches.viewBranch.secondTab,
          icon: [<SpecialtiesServicesTabIcon />, <SpecialtiesServicesTabInprogress />, <SpecialtiesServicesTabDone />],
        },
        {
          label: branches.viewBranch.thirdTab,
          icon: [<EmployeesTabIcon />, <EmployeesTabInprogress />, <EmployeesTabDone />],
        },
        {
          label: branches.viewBranch.fourthTab,
          icon: [<BookingsTabIcon />, <BookingsTabInprogressIcon />, <BookingsTabDoneIcon />],
        },
        {
          label: branches.viewBranch.fifthTab,
          icon: [<ReviewsTab />, <ReviewsTabInprogress />, <EmployeesTabDone />],
        },
      ]);
    }
  }, [isPublishRequest, lang]);

  useEffect(() => {
    setPageTitle(lang === 'en' ? branchData?.name_en : branchData?.name_ar);
  }, [lang, branchData]);

  // useEffect(() => {
  //   if (props?.location?.state?.setTabIndex) {
  //     setTabIndex(props?.location?.state?.setTabIndex);
  //   }
  // }, [props]);

  // useEffect(() => {
  //   if (props?.location?.state?.setTabIndex) {
  //     setTabIndex(props?.location?.state?.setTabIndex);
  //   }
  // }, [props]);

  const handleSelectStep = (step) => {
    history.push({ search: `?CurrentTab=${step+1}`, state: props.location.state });
  };

  const onSubTitleChange = (title) => {
    setRenderList(false);
    setRenderSubTitle(title);
  };

  const handleCloseDeleteBranchModal = () => {
    setShowDeleteBranchModal(false);
  };

  const handleConfirmDeleteBranch = () => {
    dispatch(
      deleteBranchRequest({
        id,
      })
    );
    setShowDeleteBranchModal(false);
    setTimeout(() => {
      history.push(ROUTE_PATHS.branches);
    }, 500);
  };

  const handleCloseDeleteBranchEmployeeModal = () => {
    setShowDeleteBranchEmployeeModal(false);
  };

  const handleConfirmDeleteBranchEmployee = () => {
    // history.push(ROUTE_PATHS.viewServiceProvider.replace(':id', id));
    setShowDeleteBranchEmployeeModal(false);
  };

  const handleEditBranchData = () => {
    // history.push(ROUTE_PATHS.editBranch.replace(':id', id));
    history.push({
      pathname: ROUTE_PATHS.editProvidersBranch
        .replace(':providerid', branchData?.service_provider.id)
        .replace(':branchid', branchData?.id),
      search: `?CurrentTab=${tabIndex <=2 ? tabIndex+1 : 1}`,
      state: {
        editMood: true,
        branchDataToEdit: branchData,
        setPageTitle: lang === 'en' ? branchData?.name_en : branchData?.name_ar,
        setPageTitleAr: branchData?.name_ar,
        setPageTitleEn: branchData?.name_en,
        noTranslationForTitle: true,
        setTabIndex: tabIndex,
        cameFrom: ROUTE_PATHS.viewBranch.replace(':id', id),
      },
    });
  };

  const handlepublishRequest = () => {
    dispatch(
      editBranchRequest({
        id: branchData?.id,
        data: {
          status: 2,
        },
      })
    );
  };

  const handleCloseRejectRequestModal = () => {
    setShowRejectRequestModal(false);
  };

  const handleConfirmRejectRequest = () => {
    handleSubmit();
    if (requestStatus) {
      history.push(ROUTE_PATHS.publishRequests);
    }
  };

  const handleAcceptPublishRequest = () => {
    dispatch(
      editBranchRequest({
        id,
        data: {
          status: 'active',
        },
      })
    );
    if (requestStatus) {
      history.push(ROUTE_PATHS.publishRequests);
    }
  };

  const renderRejectionReasonText = () => {
    if (branchData?.rejection_reason?.length >= 225) {
      const trimmedString = branchData?.rejection_reason.slice(0, 224);
      return trimmedString;
    }
  };

  const renderRejectRequestModelContent = () => (
    <form onSubmit={handleSubmit}>
      <Input
        id="reason"
        name="reason"
        type="text"
        label={publishRequests.rejectModal.contentText}
        placeholder={publishRequests.rejectModal.placeholder}
        required
        value={values['reason']}
        onChange={(value) => {
          setFieldTouched('reason');
          setFieldValue('reason', value);
        }}
        labelClassName="text-dark font-medium mb-2"
        isInputHasErr={!!(touched['reason'] && errors['reason'])}
        errMsg={errors['reason']}
      />
    </form>
  );

  const renderViewBranchActions = () => (
    <>
      <Button
        onClick={() => {
          // setBtnClicked('add');
          // handleAddServicesToBranch();
          setShowDeleteBranchModal(true);
        }}
        color="info"
        outlined
        label={
          <span className="d-flex align-items-center">
            <DeleteOutline fontSize="small" />
            <span>{shared.delete}</span>
          </span>
        }
        className="btn-secondary"
        labelClass="fsize-14 btn-info-generate-password"
      />
      <Button
        onClick={() => {
          handleEditBranchData();
        }}
        type="button"
        label={
          <span className="d-flex align-items-center">
            <EditOutlined fontSize="small" />
            <span className="ps-1">{shared.edit}</span>
          </span>
        }
        labelClass="fsize-16 text-white py-1"
      />
      {isSuperAdmin() &&
        (() => {
          if (branchData?.status === 'unpublished') {
            return (
              <Button
                onClick={() => {
                  handlepublishRequest();
                }}
                type="button"
                label={
                  <span className="d-flex align-items-center gap-2">
                    <span className="ps-1">{branches.viewBranch.publish}</span>
                    <SendOutlined fontSize="medium" />
                  </span>
                }
                labelClass="fsize-16 text-white py-1"
              />
            );
          } else if (branchData?.status === 'requested_publishing') {
            return (
              <Button
                disabled
                type="button"
                label={
                  <span className="d-flex align-items-center gap-2">
                    <span className="ps-1">{branches.viewBranch.requestPublishing}</span>
                    <SendOutlined fontSize="medium" />
                  </span>
                }
                labelClass="fsize-16 text-white py-1"
                className="w-60"
              />
            );
          } else {
            return (
              <Button
                disabled
                type="button"
                label={
                  <span className="d-flex align-items-center gap-2">
                    <span className="ps-1">{branches.addBranch.specialtiesAndServices.publishedRequest}</span>
                    <SendOutlined fontSize="medium" />
                  </span>
                }
                labelClass="fsize-16 text-white py-1"
              />
            );
          }
        })()}
    </>
  );

  const renderPublishRequestActions = () => (
    <>
      <Button
        onClick={() => {
          setShowRejectRequestModal(true);
        }}
        color="info"
        outlined
        label={publishRequests.card.rejectLabel}
        className="w-40"
        labelClass="fsize-15 fweight-400 "
      />
      <Button
        onClick={() => {
          handleAcceptPublishRequest();
        }}
        label={publishRequests.card.acceptLabel}
        className="w-40"
        labelClass="fsize-15 fweight-400 text-white"
      />
    </>
  );

  return (
    <>
      <div className="add-branch-page">
        <div className="header d-flex flex-column flex-md-row mb-3 ">
          {isPublishRequest ? (
            <div className="flex-grow-1">
              <Breadcrumbs
                list={[
                  {
                    path: ROUTE_PATHS.publishRequests,
                    label: branches.viewBranch.publishRequests,
                  },
                  {
                    path: '#',
                    label: lang === 'en' ? branchData?.name_en : branchData?.name_ar,
                  },
                ]}
                className="fsize-28 fweight-600"
              />
            </div>
          ) : (
            <Typography variant="h4" sx={{ flexGrow: 1 }} className={`page-title mb-4`}>
              <div className="d-flex flex-column flex-md-row">
                <div
                  className={`${renderSubTitle !== null && 'pointer'}`}
                  onClick={() => {
                    setBtnClicked('list');
                    setRenderSubTitle(null);
                    setRenderList(true);
                  }}>
                  {renderTextEllipsis(pageTitle)}
                </div>
                {renderSubTitle !== null && <div> / {branches.addBranch.labels[renderSubTitle]}</div>}
                {renderServiceTitle !== null && renderSubTitle !== null && <div> / {renderServiceTitle}</div>}
              </div>
            </Typography>
          )}
          <div className={`ms-auto ${isPublishRequest && 'w-20'}`}>
            <div className="d-flex justify-content-end gap-2">
              {isPublishRequest ? renderPublishRequestActions() : renderViewBranchActions()}
            </div>
          </div>
        </div>
        {branchData?.status === 'unpublished' && branchData?.rejection_reason != null && (
          <div className="reject-reason-container px-3 py-1 mb-5">
            <div className="d-flex gap-1 fsize-20 fweight-500">
              <div>
                <FlagOutlined fontSize="fsize-18 fweight-500" />
              </div>
              <div className="mt-1">{publishRequests.viewPublishRequest.rejectionFlag}</div>
            </div>
            <div className="px-1 fsize-18 fweight-400">
              {branchData?.rejection_reason?.length <= 225 ? (
                <div className="fsize-18 fweight-400">{branchData?.rejection_reason}</div>
              ) : (
                <div>
                  <span className="me-2 fsize-18 fweight-400">{renderRejectionReasonText()}</span>
                  <span className="fsize-18">
                    <MoreHoriz fontSize="fweight-500" />
                  </span>
                  <button
                    className="see-more-btn fsize-18 fweight-500"
                    onClick={() => {
                      setShowRejectionReason(true);
                    }}>
                    {publishRequests.viewPublishRequest.seeMore}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="add-branch-stepper">
          <Stepper
            steps={stepperItems}
            // handleSelectStep={(index) => setTabIndex(index)}
            handleSelectStep={handleSelectStep}
            currentStep={tabIndex}
            preventGoingBack={false}
            haveBranchId={true}
            haveServices={branchData?.specialties?.length > 0}
            allTabsIsClicable={true}
          />
        </div>

        <div className="page-container mt-5">{tabIndex === 0 && <ViewBranchDetails />}</div>
        <div className="page-container mt-5">{tabIndex === 1 && <ViewServicesDetails isPublishRequest={isPublishRequest} />}</div>
        <div className="page-container mt-5">
          {tabIndex === 2 && (
            <ViewEmployeesDetails btnClicked={btnClicked} changeSubTitle={onSubTitleChange} renderList={renderList} />
          )}
        </div>
        <div className="page-container mt-5">
          {tabIndex === 3 && (
            <ViewBookingsDetails
              btnClicked={btnClicked}
              changeSubTitle={onSubTitleChange}
              renderList={renderList}
              // backToPrevStep={() => setTabIndex(1)}
              backToPrevStep={() => handleSelectStep(1)}
            />
          )}
        </div>
        <div className="page-container mt-5">{tabIndex === 4 && <ViewReviewsDetails />}</div>
      </div>
      <Modal
        open={showDeleteBranchModal}
        handleClose={handleCloseDeleteBranchModal}
        title={branches.deleteBranch.title}
        contentClass="mb-5 pb-2 text-primary"
        content={<span>{branches.deleteBranch.deleteConfirmationMsg}</span>}
        confirmBtnTxt={shared.confirm}
        maxWidth="xs"
        cancelBtnTxt={shared.cancel}
        isContentText={false}
        handleConfirm={handleConfirmDeleteBranch}
        handleCancel={handleCloseDeleteBranchModal}
        modalClass="delete-services-modal"
        actionsClass="container px-4"
        confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
        cancelBtnClass="fsize-14 py-2"
      />
      <Modal
        open={showDeleteBranchEmployeeModal}
        handleClose={handleCloseDeleteBranchEmployeeModal}
        title={branches.deleteBranch.titleEmployee}
        contentClass="mb-5 pb-2 text-primary"
        content={<span>{branches.deleteBranch.deleteEmployeeConfirmationMsg}</span>}
        confirmBtnTxt={shared.confirm}
        maxWidth="xs"
        cancelBtnTxt={shared.cancel}
        isContentText={false}
        handleConfirm={handleConfirmDeleteBranchEmployee}
        handleCancel={handleCloseDeleteBranchEmployeeModal}
        modalClass="delete-services-modal"
        actionsClass="container px-4"
        confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
        cancelBtnClass="fsize-14 py-2"
      />
      <Modal
        open={showRejectRequestModal}
        handleClose={handleCloseRejectRequestModal}
        title={publishRequests.rejectModal.title}
        contentClass="mb-5 pb-2 text-primary"
        content={renderRejectRequestModelContent()}
        confirmBtnTxt={shared.confirm}
        maxWidth="xs"
        cancelBtnTxt={shared.cancel}
        isContentText={false}
        handleConfirm={handleSubmit}
        handleCancel={handleCloseRejectRequestModal}
        modalClass="delete-services-modal"
        actionsClass="container px-4"
        confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
        cancelBtnClass="fsize-14 py-2 text-secondary"
        disableActionBtn={!!(!touched['reason'] || errors['reason'])}
      />
      <Modal
        open={showRejectionReason}
        handleClose={() => {
          setShowRejectionReason(false);
        }}
        title={publishRequests.rejectModal.contentText}
        contentClass="mb-5 pb-2 text-primary"
        content={<span>{branchData?.rejection_reason}</span>}
        maxWidth="xs"
        isContentText={false}
      />
    </>
  );
};

export default ViewBranch;
